import React from 'react';
import _ from 'root/libs/exaforte/react/lodash';
import ReactController from 'root/libs/exaforte/react/ReactController';
import ReactModel from 'root/libs/exaforte/react/ReactModel';

export default class CustomComponent extends React.Component {
    static ignorePropsOnComponentUpdateCheck() {
        return [];
    }
    
    static ignoreStatesOnComponentUpdateCheck() {
        return [];
    }
    
    static filterComponentUpdateObject(object, excludedKeys) {
        object = _.filterExcludedProps(object, excludedKeys);
        
        return _.pickBy(object, (value, key) => {
            if(value instanceof ReactModel)
                return false;

            if(value instanceof ReactController)
                return false;

            if(React.isValidElement(value))
                return false;

            return true;
        });
    }
    
    constructor(props, context) {
        super(props, context);
        
        this.cache                  = this.props.cache;
        this.setStateAsync          = this.setStateAsync.bind(this);
        this.createStateVariable    = this.createStateVariable.bind(this);
        let prototype               = this.constructor.prototype;
        let binded_methods          = [];
        
        // Door de prototypes heen loopen en de methods die met _ beginnen binden.
        while(prototype != CustomComponent.prototype)
        {
            let methods = Object.getOwnPropertyNames(prototype);
            
            for(let i in methods)
            {
                if(!_.includes(binded_methods, methods[i]) && methods[i].substr(0,1) == '_')
                {
                    this[methods[i]] = this[methods[i]].bind(this);
                    
                    binded_methods.push(methods[i]);
                }
            }
            
            prototype = Object.getPrototypeOf(prototype);
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        if(!this.cache)
            return true;
        
        return !_.isEqual(this.constructor.filterComponentUpdateObject(this.props, [...this.constructor.ignorePropsOnComponentUpdateCheck(), 'children']), this.constructor.filterComponentUpdateObject(nextProps, [...this.constructor.ignorePropsOnComponentUpdateCheck(), 'children'])) || !_.isEqual(this.constructor.filterComponentUpdateObject(this.state, this.constructor.ignoreStatesOnComponentUpdateCheck()), this.constructor.filterComponentUpdateObject(nextState, this.constructor.ignoreStatesOnComponentUpdateCheck()));
    }

    setStateAsync(state) {
        return new Promise(resolve => this.setState(state, resolve));
    }
    
    createStateVariable(name, start_value = null) {
        const name_parts    = name.split('_');
        let function_name   = 'set';
        
        for(let i in name_parts)
            function_name += _.upperFirst(name_parts[i]);
        
        if(typeof this.state === 'undefined')
            this.state = {};
        
        this.state.name     = start_value;
        this[function_name] = (function(value) { this.setState({ [name]: value }); }).bind(this);
    }

    render() {
        return <>{this.props.children}</>;
    }
};

CustomComponent.defaultProps = {
    cache: false
};